'use client';
import { useState } from 'react';

import type { OutStockClubCoinDialogProps } from '@wwe-portal/ui/features/club-store/dialog/outstock-clubcoin-dialog';

export const useOutStockClubCoinState = () => {
  const [open, setOpen] = useState(false);

  const props: OutStockClubCoinDialogProps & { show: () => void } = {
    show: () => {
      setOpen(true);
    },
    onClose: () => {
      setOpen(false);
    },
    open,
  };
  return props;
};
